var rPjaxRoute = /\/(shouyou-list|vr-list|game-list)/
  , rWithHttp = /^http/i
  , rNewgame = /(newgame\.17173\.com|newgame\.test\.17173\.com)/
  , $ = require('jquery')
  , urlUtils = require('@173js/url')
  , pingjs = require('widgets/ping.js')

function getPathname(url) {
  var parts = url.split('/')
    , pathnameStartIndex = 3

  return '/' + parts.slice(pathnameStartIndex).join('/')
}

module.exports = function(e) {
  var link = $(e.currentTarget)
    , href = link.attr('href')
    , title = $('title')

  if (!rPjaxRoute.test(href) || link.data('ignore-pjax')) { return }

  if (rWithHttp.test(href) && rNewgame.test(href)) {
    href = getPathname(href)
  }

  e.preventDefault()

  var currentHref = urlUtils.getRelativeUrl(
    window.location.href, window.location.origin
  )

  if (currentHref === href) { return }

  history.pushState({}, title, href)
  this.model.trigger('changeRoute')
  pingjs.trackPageview()

  var linkIsPaginationItem = !!link.closest('.pagination', this.$el).length

  if (linkIsPaginationItem || link.data('pjax-to-top')) { window.scrollTo(0, 0) }
};
